<template>
  <div class="widget-report">
    <!--Widget Header-->
    <div class="row no-gutters card-header text-white">
      <!--Widget Name-->
      <div class="col-5 d-inline-block widget-title">
        {{ widgetInfo.widgetTitle }}
      </div>
      <!--Widget Link-->
      <div  class="col-7 d-inline-block text-right smaller-font-content">
        <div class="row justify-content-end">
            <!--Product Filter-->
            <div v-if="productFilters && hasOptions(productFilters)" class="tabs d-flex mx-2 p-filter">
              <filter-products :widgetType="'select'" :fieldData="productFilters" class="d-block w-auto"></filter-products>
            </div>
            <!--Date Range Filter-->
            <div v-if="chartDateFiltersPrimary && hasOptions(chartDateFiltersPrimary)" class="tabs d-flex mx-2">
              <filter-daterange :widgetType="'select'" :fieldData="chartDateFiltersPrimary" class="d-block w-auto"></filter-daterange>
            </div>
        </div>
        <div v-if="widgetInfo.route">
          <router-link :to="{ name: widgetInfo.route }" class="align-middle text-white">
            <span>{{ widgetInfo.linkTitle }}</span><i class="fas fa-angle-right ml-1"></i>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="widgetType === 'report' || widgetType === 'list'" class="data-table" style="-webkit-transform: none; transform: none; perspective: none; filter: none;">
      <datatable-block :dataFilters="dataFilters"
      :persistentDimension="null"
      :tableData="reportDataPrimary"
      :tableDataSecondary="reportDataSecondary"
      :chartFiltersFilters="{}"
      :dimensionProperty="dimensionProperty"
      :widgetType="widgetType"
      :isLoading="isLoading">
      </datatable-block>
    </div>

    <div class="data-chart" v-if="widgetType === 'chart'">
      <canvas ref="report-card-002" id="report-card-002" width="80%" height="70"></canvas>
    </div>

    <div class="widget-loader">
      <div v-show="isLoading" class="loader-content text-center">
        <i class="fas fa-circle-o-notch fa-spin mr-1"></i>Loading&hellip;
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
/* eslint-disable */
import Report from '@/services/Report';
import DatatableBlock from '@/components/presentational/DatatableBlock';
import FilterDaterange from '@/components/interactive/widgets/FilterDaterange';
import FilterProducts from '@/components/interactive/widgets/FilterProducts';
import QRP from '../../../../config/QRP.env';

export default {
  props: ['fieldData', 'widgetData', 'widgetInfo', 'chartDateFiltersPrimary', 'productFilters', 'widgetType'],
  data() {
    return {
      isLoading: false,
      chart: {
        type: 'doughnut', // TODO: Use config values
        el: 'report-card-002',
        xAxis: (this.widgetInfo ? this.widgetInfo.xAxis : 'CustomerCount'), // TODO: Use config values
        yAxis: (this.widgetInfo ? this.widgetInfo.yAxis : 'CarrierName'), // TODO: Use config values
        calc: 'sum',
      },
      reportDataPrimary: {
        columns: [],
        rows: [],
      },
      reportDataSecondary: {
        columns: [],
        rows: [],
      },
      target: 'primary',
      dataFilters: this.widgetData,
      isNewChart: true,
      savedChartData: [],
      colorTemplates: [
        'rgba(124, 222, 220, ',
        'rgba(114, 132, 168, ',
        'rgba(45, 77, 66, ',
        'rgba(251, 170, 35, ',
        'rgba(104, 92, 168, ',
        'rgba(237, 132, 231, ',
        'rgba(193, 154, 183, ',
        'rgba(222, 242, 200, ',
        'rgba(4, 231, 98, ',
        'rgba(44, 172, 255, ',
        'rgba(255, 87, 87, ',
        'rgba(255, 222, 0, ',
        'rgba(84, 13, 110, ',
        'rgba(137, 99, 186, ',
        'rgba(30, 26, 29, ',
        'rgba(155, 40, 123, ',
        'rgba(235, 186, 185, ',
        'rgba(226, 252, 239, ',
        'rgba(244, 96, 54, ',
        'rgba(215, 38, 61, ',
        'rgba(12, 202, 74, ',
      ],
      loadLabels: [],
      loadMetrics: [],
      loadBgColors: [],
      loadBorderColors: [],
      totalNum: 0,
    };
  },
  components: {
    DatatableBlock,
    FilterDaterange,
    FilterProducts,
  },
  computed: {
    dimensionProperty() {
      return (Array.isArray(this.dataFilters.dimensions) ? this.dataFilters.dimensions[0] : false);
    },
  },
  methods: {
    /**
     * Returns whether a data object has a `values` array (which are used for options).
     */
    hasOptions(data) {
      return (data && data.values && data.values.length);
    },
    createChart(reportDataPrimary, displayType, el) {
      this.totalNum = reportDataPrimary.metrics.reduce((a, b) => a + b, 0);
      /**
       * Implementation of deterministic relationship between carriers and colors.
       */
      if (this.isNewChart) {
        reportDataPrimary.labels.forEach((item, i) => {
          this.savedChartData.push({
            label: item,
            bgColor: `${this.colorTemplates[i]}0.5)`,
            borderColor: `${this.colorTemplates[i]}1)`,
            metrics: reportDataPrimary.metrics[i],
          });
        });
        this.isNewChart = false;
      } else {
        reportDataPrimary.labels.forEach((v, i) => {
          let cIndex = -1;
          const isInSaved = this.savedChartData.some((sv, si) => {
            if (sv.label === v) {
              cIndex = si;
            }
            return (sv.label === v);
          });
          if (!isInSaved) {
            this.savedChartData.push({
              label: v,
              bgColor: `${this.colorTemplates[i]}0.5)`,
              borderColor: `${this.colorTemplates[i]}1)`,
              metrics: reportDataPrimary.metrics[i],
            });
          } else {
            this.savedChartData[cIndex].metrics = reportDataPrimary.metrics[i];
          }
        });
      }
      this.savedChartData.forEach((v, i) => {
        const cIndex = reportDataPrimary.labels.indexOf(v.label);
        if (cIndex === -1) {
          this.savedChartData[i].metrics = 0;
        }
      });

      const filteredData = this.savedChartData.filter(item => item.metrics);

      this.loadLabels = filteredData.map(item => item.label);
      this.loadMetrics = filteredData.map(item => item.metrics);
      this.loadBgColors = filteredData.map(item => item.bgColor);
      this.loadBorderColors = filteredData.map(item => item.borderColor);
      const Chart = require('chart.js'); // eslint-disable-line global-require
      // http://jsfiddle.net/nkzyx50o/
      Chart.pluginService.register({
        beforeDraw: (chart) => {
          if (chart.config.options.elements.center) {
            const ctx = chart.chart.ctx;
            const centerConfig = chart.config.options.elements.center;
            const fontStyle = centerConfig.fontStyle || 'Arial';
            const txt = centerConfig.text;
            const color = centerConfig.color || '#000';
            const sidePadding = centerConfig.sidePadding || 20;
            const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
            ctx.font = `30px ${fontStyle}`;
            const stringWidth = ctx.measureText(txt).width;
            const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
            const widthRatio = elementWidth / stringWidth;
            const newFontSize = Math.floor(20 * widthRatio);
            const elementHeight = (chart.innerRadius * 2);
            const fontSizeToUse = Math.min(newFontSize, elementHeight);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
            const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
            ctx.font = `12px ${fontStyle}`;
            ctx.fillStyle = color;
            ctx.fillText(txt, centerX, centerY);
          }
        },
      });
      if (!reportDataPrimary || !displayType || !el) {
        window.console.warn('Data, displayType, or element is undefined. The chart will render with no data.');
      }

      /**
       * For debugging and reporting warnings, all y values are checked to be valid
       * numbers. It will not short-circuit since it is still valid, but the warning
       * will be logged.
       */
      if (!reportDataPrimary.metrics.every(element => typeof element === 'number' && !isNaN(element))) {
        gtag('event', 'exception', {
          description: `At least one y value is not a number in chart '${reportDataPrimary.label}'.`,
          fatal: false, // set to true if the error is fatal
        });
      }

      switch (displayType) {
        case 'bar':
        case 'horizontalBar':
        case 'polarArea':
        case 'line':
        case 'doughnut':
          if (this.reportCard instanceof Chart) {
            this.reportCard.destroy(); // Destroy current chart so that the canvas is empty
          }

          this.reportCard = new Chart(this.$refs[el], {
            type: displayType,
            data: {
              labels: this.loadLabels,
              datasets: [{
                label: reportDataPrimary.label, // y-axis labels
                data: this.loadMetrics, // y-axis data points
                backgroundColor: this.loadBgColors,
                borderColor: this.loadBorderColors,
                borderWidth: 1,
              }],
            },
            options: {
              elements: {
                center: {
                  text: `Total: ${this.totalNum}`,
                  color: '#003366',
                  fontStyle: 'Arial',
                  sidePadding: 20,
                },
              },
              responsive: true,
              legend: {
                position: 'bottom',
              },
            },
          });
          break;

        case 'line-chart':
          break;

        default:
          break;
      }
    },
    createChartFromTable(reportDataPrimary, displayType, el, xAxis, yAxis, yMath) {
      window.console.info('Preparing chart from table.');
      /**
       * Get running average of each x coordinate's y values. This needs to be a closure
       * since the function doesn't know how many values there will be for the denominator.
       */
      function GetAverage() {
        let value = 0; // Value to be added to the numerator
        let denominator = 0; // Value to be incremented as the denominator

        function addNumerators(valueToAdd) {
          function calcAverage() {
            return value / denominator;
          }

          if (typeof valueToAdd !== 'undefined') {
            value += valueToAdd; // Add new value to numerator
            denominator += 1; // Increment denominator
          }

          return calcAverage(); // Return current average
        }

        return addNumerators; // Return closure that will calculate the running average
      }

      const chartData = {
        labels: [],
        label: reportDataPrimary.label, // Add table title
        metrics: {},
      };

      if (reportDataPrimary.rows) {
        const rows = reportDataPrimary.rows;
        const yCalcValue = []; // Used as temporary holder of y value calculations

        for (let i = 0; i < rows.length; i += 1) {
          const xValue = rows[i][xAxis];
          const yValue = rows[i][yAxis];

          if (typeof chartData.metrics[xValue] === 'undefined') {
            chartData.metrics[xValue] = 0; // Initialize metric to 0
          }

          switch (yMath) {
            case 'sum':
              chartData.metrics[xValue] += yValue; // Add y value to its corresponding x
              break;

            case 'avg':
              if (typeof yCalcValue[xValue] !== 'function') {
                yCalcValue[xValue] = new GetAverage();
              }

              chartData.metrics[xValue] = yCalcValue[xValue](yValue); // Calculate average with new value to its corresponding x
              break;

            default:
              if (i === 0) {
                gtag('event', 'exception', {
                  description: `Unknown calc type of '${yMath}' was used to create a chart.`,
                  fatal: false, // set to true if the error is fatal
                });
              }
              break;
          }
        }

        chartData.labels = Object.keys(chartData.metrics); // Add x-axis (i.e. carriers) name to the list of labels
        chartData.metrics = Object.values(chartData.metrics); // Add y-axis values (i.e. summed up quote count) to metrics
      } else {
        chartData.labels = reportDataPrimary.labels;
        chartData.metrics = reportDataPrimary.metrics;
      }

      this.createChart(chartData, displayType, el); // Create chart!
    },
    requestActivityTable() {
      this.isLoading = true;

      Report.requestActivityTable(
        this.dataFilters,
        this.target,
      ).then((response) => {
        this.isLoading = false;

        this.reportDataPrimary = response;

        if (this.widgetType === 'chart') {
          this.createChartFromTable(this.reportDataPrimary, this.chart.type, this.chart.el, this.chart.yAxis, this.chart.xAxis, this.chart.calc);
        }
      });
    },
  },
  mounted() {
    this.requestActivityTable('mounted');
  },
  watch: {
    // Updates chart when chartDateFiltersPrimary changes (API request)
    'chartDateFiltersPrimary.field_value': function chartDateFiltersPrimary(newValue) {
      this.dataFilters.dateRange = newValue;

      this.requestActivityTable('date filter');
    },
    // Updates chart when productFilters changes (API request)
    'productFilters.field_value': function productFilters(newValue) {
      this.dataFilters.productId = newValue;
      this.requestActivityTable('product filter');
    },
  },
};
</script>

<style scoped>
.card-header {
  padding: 0.5rem 1.25rem;
  background-color: #00162B;
  border-bottom: none;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0 !important;
}

.data-table {
  height: 210px;
  overflow-y: auto;
  overflow-x: auto;
}

.widget-report {
  overflow-x: hidden;
}

/**WIDGET LOADING ANIMATION**/
.widget-loader .loader-content{
  position: absolute;
  top: 37%;
  left: 0;
  right: 0;
  max-width: 150px;
  min-width: 150px;
  padding: 0.5rem;
  margin: auto;
  color: #3674B2;
  background:rgba(255,255,255, 0.8);
  border-radius: 0.25rem;
}

/**WIDGET ICONS**/
.card .widget-title::before {
  margin-right: 0.25rem;
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  font-weight: 900;
  color: #FFFFFF;
}
  .card.recent-quotes .widget-title::before {
    content: "\f0ca";
  }
  .card.recent-sales .widget-title::before {
    content: "\f46c";
  }
  .card.sales-by-state .widget-title::before {
    content: "\f5a0";
  }
  .card.sales-by-agent .widget-title::before {
    content: "\f590";
  }
  .card.sales-by-carrier .widget-title::before,
  .card.quotes-by-carrier .widget-title::before {
    content: "\f0e9";
  }
  .card.sales-by-product .widget-title::before {
    content: "\f468";
  }
.data-chart {
  position: relative;
  width: 90%;
  margin-left: 5%;
  min-width: 20
}
@media (max-width: 1319px) {
  .card.sales-by-state .p-filter, .card.sales-by-agent .p-filter {
    margin-bottom: 5px;
  }
}
@media (max-width: 1880px) {
  .card.quotes-by-carrier .p-filter, .card.sales-by-carrier .p-filter, .card.sales-by-state .p-filter, .card.sales-by-agent .p-filter {
    margin-bottom: 5px;
  }
}
</style>
<style>
i.fa-circle-o-notch:before{
  content: "\f1ce";
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  color: #3674B2;
}

/**DATE RANGE FILTER TABS**/
.widget-report .tabs .btn-group {
  width: 100%;
}
  .widget-report .tabs .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .widget-report .tabs .btn-group > .btn-group:not(:last-child) > .btn {
    border-radius: 0;
  }
    .widget-report .tabs .btn-group label {
      margin-bottom: 1rem;
    }
      .widget-report .tabs label.btn {
        padding: 0.25rem 0.5rem 0.375rem;
        color: #3674B2;
        text-transform: capitalize;
        border: none;
      }
        .widget-report .tabs label.btn.active {
          color: #FFFFFF;
          background: #3674B2;
          border-radius: 0 0 0.25rem 0.25rem !important;
        }
          .widget-report .tabs label.btn.active:first-child {
            border-radius: 0 0 0.25rem 0 !important;
          }
          .widget-report .tabs label.btn.active:last-child {
            border-radius: 0 0 0 0.25rem !important;
          }

</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/ReportWidget.vue?41a75db6